export default class Details {
	constructor($scope,
				$routeParams,
				panelService,
				ottService,
				incidenciaService,
				preincidenciaService,
				inventarioService,
				$location,
                toastr,
                dataEstadistica,
				calendarioService,
				clientesService,
				proyectosService,
				columnasService,
				prioridadesService
				){

		this.scope    = $scope;
		this.location = $location;
		this.toastr = toastr;
		this.panelService = panelService;
		this.ottService = ottService;
		this.incidenciaService = incidenciaService;
		this.preincidenciaService = preincidenciaService;
		this.inventarioService = inventarioService;
		this.dataEstadistica = dataEstadistica;
		this.calendarioService = calendarioService;
		this.clientesService = clientesService;
		this.proyectosService = proyectosService;
		this.prioridadesService = prioridadesService;
		this.columnasService = columnasService;
		this.scope.columnas = this.columnasService.columnas.ott[localStorage.getItem('cliente')];
		this.nombreObjetos = {
			incidenciaService: 'incidencias',
			ottService: 'otts',
			preincidenciaService: 'preincidencias',
			inventario: 'aux.equipos',
			calendarioService: 'otts'
		};
		if(this.dataEstadistica.tipo === 'calendario' || this.dataEstadistica.tipo === 'calendarioService' ) {
			this.getMisOTTsP();
		}else {
			this.get();
		}
	}

	get() {
		if (!this.dataEstadistica.tipo.match('Service')) {
			this.dataEstadistica.tipo = this.dataEstadistica.tipo.toLowerCase() + 'Service';
		}		

		this[this.dataEstadistica.tipo].getAll(this.dataEstadistica.criterio).then((resp, err) => {
				if (err || resp.status !== 200) {
					this.toastr.error('Error', err, {
	                    timeOut: 2000,
	                    closeButton: true
	                });
				}else{					
					this.scope[this.nombreObjetos[this.dataEstadistica.tipo]] = resp.data.message;					
				}				
			})
			.catch((data) => {
				this.toastr.error('Error', 'Backend no responde', {
                    timeOut: 2000,
                    closeButton: true
                });
			});
	}

	getMisOTTsP() {

		this.scope.nombre = "Ordenes de Trabajo";
		this.scope.showColumnGlpi = false;
		let self = this.scope;
		this.scope.aux = {
            cliente: null,
            clientes: [],
            proyecto: null,
            proyectos: []
		};
		
		if (!this.dataEstadistica.tipo.match('Service')) {
			this.dataEstadistica.tipo = this.dataEstadistica.tipo.toLowerCase() + 'Service';
		}		

		this[this.dataEstadistica.tipo].getAll(this.dataEstadistica.criterio).then((resp, err) => {
				if (err || resp.status !== 200) {
					this.toastr.error('Error', err, {
	                    timeOut: 2000,
	                    closeButton: true
	                });
				}else{					
					this.scope[this.nombreObjetos[this.dataEstadistica.tipo]] = resp.data.message;					
				}				
			})
			.catch((data) => {
				this.toastr.error('Error', 'Backend no responde', {
                    timeOut: 2000,
                    closeButton: true
                });
			});


		this.clientesService.getAll()
            .then((resp) => {
                let data = resp.data.message.map((el) => {
                    el.nombre_interno = "proyecto.cliente._id";
                    return el;
                });
                this.scope.aux.clientes = data;
			});

		this.scope.$watch('aux.cliente', (nuevo) => {
			if (nuevo) {
				let filter = {
					"cliente._id": nuevo._id
				};
				filter = JSON.stringify(filter);
				this.proyectosService.getAll({string: filter})
					.then((resp) => {
						let data = resp.data.message.map((el) => {
							el.nombre_interno = "proyecto";
							return el;
						});
						this.scope.aux.proyectos = data;
					});
			} else {
				this.scope.aux.proyectos = [];
			}
		});

		this.prioridadesService.getAll()
            .then((resp) => {
                let data = resp.data.message.map((el) => {
                    el.nombre_interno = "prioridad._id";
                    return el;
                });
                this.scope.aux.prioridades = data;
			});
			
		var ar_watch = ['aux.cliente', 'aux.proyecto', 'aux.prioridad', 'aux.tipo', 'aux.desde', 'aux.hasta'];

		this.scope.$watchGroup(ar_watch, (nuevo) => {

			let filtro = {};
			
			for (var el in nuevo) {
				let element = nuevo[el];
				if (element) {
					if (element._id) {
						filtro[element.nombre_interno] = element._id;
					} else if(element === 'correctiva'){
                        filtro['preventiva'] = true;
                    } else if(element === 'preventiva'){
                        filtro['preventiva'] = false;
                    } else {
                        if(el == 4 && typeof nuevo[5] === 'undefined') {
							var timezone = self.desde._d.getTimezoneOffset();
                            filtro['fecha_agendada'] = {"$gte": self.desde._d.getTime() - (timezone*60*1000)  }
                        } else if(el == 5 && typeof nuevo[4] === 'undefined') {
							var timezone = self.hasta._d.getTimezoneOffset();
                            filtro['fecha_agendada'] = { "$lt": (self.hasta._d.getTime() + 86400000) - (timezone*60*1000)  }
                        } else if(el == 4 && typeof nuevo[5] !== 'undefined') {
							var timezone = self.desde._d.getTimezoneOffset();
                            filtro['fecha_agendada'] = {"$gte": self.desde._d.getTime() - (timezone*60*1000)  , "$lt": (self.hasta._d.getTime() + 86400000)- (timezone*60*1000) }
                        } else {
                            filtro[element.tipo_p] = element.valor;
                        }
                    }
				}
			}

			this.scope.aux.query = filtro;
			filtro = JSON.stringify(filtro);
			
			this.ottService.misPendientes(filtro)
				.then((resp, err) => {
					if (!err) {
						this.scope.otts = [];
						this.scope.otts = resp.data.message;
						this.scope.otts.forEach(function(orden){
							if(typeof orden.proyecto.no_requeridos !== 'undefined' &&
								typeof orden.proyecto.no_requeridos.ott !== 'undefined') {
									if(orden.proyecto.no_requeridos.ott.indexOf('avance') > -1) {
										self.showColumnAvance = false;
									}
									if(orden.proyecto.no_requeridos.ott.indexOf('equipo') > -1) {
										self.showColumnEquipo = false;
									}
									if(orden.proyecto.cliente.abreviacion.toString() == "ACSA"){
                                        self.showColumnGlpi = true;
									}
							}
						});
					} else {
						console.log(err);
					}
				});
		});
			
		this.scope.showOtt = (orden) => {
            this.location.path('/ott/' + orden._id);
		};
		this.scope.getUbicacion = this.getUbicacion.bind(this);
		this.scope.getTipo = this.getTipo.bind(this);
	}

	getUbicacion(orden) {
		if (orden.proyecto.abreviacion == 'AVO1') {
			return orden.ubicacion.posicion.descripcion;
		} else if(typeof orden.equipo === 'undefined') {
            let result = false;
            if(orden !== 'undefined' && orden != null) {
                let proyecto = orden.proyecto;
                if (typeof proyecto !== "undefined" && proyecto != null) {
                    if (typeof proyecto.no_requeridos !== "undefined" && proyecto.no_requeridos != null) {
                        if (typeof proyecto.no_requeridos.ott !== "undefined" && proyecto.no_requeridos.ott != null) {
                            result = proyecto.no_requeridos.ott.indexOf('equipo') == -1;
                        }
                    }
                }
            }
            if(result) {
                let resp = '';
                for (var el in orden.ubicacion) {
                    let element = orden.ubicacion[el].nombre;
                    resp += element + '/ ';
                }
                return resp;
            } else {
                return typeof orden.ubicacion.posicion !== 'undefined' ? orden.ubicacion.posicion.nombre : '-';
            }
        } else {
            let resp = '';
            for (var el in orden.equipo.ubicacion) {
                let element = orden.equipo.ubicacion[el].nombre;
                resp += element + '/ ';
            }
            return resp;
        }
    };
	
	getTipo(orden) {
        let tipo = "Preventiva"
        if(typeof orden.incidencia != 'undefined') {
            tipo = "Correctiva";
        }
        return tipo;
    };
}


// WEBPACK FOOTER //
// ./app/js/controllers/panel/detail.js